export default "__VITE_ASSET__d60c6ba3__"